import React from 'react'
import styles from './EmptyListMessage.module.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxOpen } from '@fortawesome/pro-solid-svg-icons'

interface IEmptyListMessage {
  message?: string
  className?: string
}

const EmptyListMessage: React.FC<IEmptyListMessage> = ({
  message,
  className,
  children,
}) => {
  return (
    <div className={`${styles.emptyList} ${className}`}>
      <FontAwesomeIcon
        className="mb-4"
        icon={faBoxOpen}
        size="4x"
      ></FontAwesomeIcon>
      {message && <p className="mb-0">{message}</p>}
      {children}
    </div>
  )
}

export default EmptyListMessage
